import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { CircularProgress, IconButton } from "@mui/material";
import "./CreateTicket.css";
import TicketFieldsForm from "../Components/TicketFieldsForm";

import {
  getCaseCount,
  getSystemParameter,
  insertTicket,
  upload,
} from "../Store/Actions/TicketAction";

import { GET_CONTACT_DETAILS } from "../Store/Types/ContactTypes";
import { RESET_CALL_STATE, SET_GO_TO_ACW } from "../Store/Types/CallTypes";
import { stateAction } from "../Store/Actions/AuthAction";
import { setSocketNotification } from "../Store/Actions/CallAction";
import { TICKET_CREATED } from "../Store/Types/SocketTypes";

const CreateTicket = ({
  chatListID,
  chatSource,
  contactDetailData,
  contactDetailDataEmail,
  contactID,
  email,
  handleEndChat,
  mobileNo,
  setTicketAction,
  setIsCreateTicketDialogShown,
}) => {
  const { myInfo } = useSelector((state) => state.auth);

  const { isInACW, phoneNumber, stateCall } = useSelector(
    (state) => state.call
  );

  const mapChatSource = () => {
    switch (chatSource) {
      case "FBCHAT":
        return 7;

      case "IG":
        return 8;

      case "LIVECHAT":
        return 5;

      case "WABA":
        return 9;

      default:
        break;
    }
  };

  const initialData = {
    // Commented keys might be used later
    ticketno: "",
    contactid: chatSource ? mapChatSource() : "",
    customerid: contactID,
    // productid: '',
    // categoryid: '',
    typeid: "",
    subtypeid: "",
    subsubtypeid: "",
    priorityid: "",
    title: "",
    description: "",
    // createddate: '',
    createdby: myInfo.user.AgentID,
    // lastupdatedate: '',
    lastupdateby: myInfo.user.AgentID,
    statusid: "",
    departmentid: "",
    // levelid: '',
    // departmentmistakeid: '',
    phoneno: contactDetailData
      ? contactDetailData.PhoneNo
      : phoneNumber
      ? phoneNumber
      : mobileNo
      ? mobileNo
      : "",
    // flexdelete: '',
    // customfield1: '',
    // customfield2: '',
    // timeesca: '',
    // customerid2: '',
    userid: myInfo.user.AgentID,
    // hduserid: '',
    email: email
      ? email
      : contactDetailDataEmail
      ? contactDetailDataEmail.PhoneNo
      : "",
    // emailsent: '',
    // smssent: '',
    resolution: "",
    // reqescalate: '',
    // sub3typeid: '',
    // approvalstatus: '',
    // approvaltime: '',
    // approvalby: '',
    // ccdepartmentid: '',
    // isreopen: '',
    // isread: '',
    // campaigncode: '',
    // masterdatauid: '',
    // clientid: '',
    // messageid: ''
    attachment: [],
    casecontrolvalue: [],
    messageid: stateCall.RecFileName ? stateCall.RecFileName : null,
    fkchatlistid: chatListID,
    remark: "",
    calltype: stateCall.CallType ? stateCall.CallType : null,
  };

  const [isTicketFieldsLoading, setIsTicketFieldsLoading] = useState(true);
  const [formData, setFormData] = useState(initialData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attachment, setAttachment] = useState({});
  const [customInput, setCustomInput] = useState([]);
  const [isCustomInputLoading, setIsCustomInputLoading] = useState(true);
  const [isDescriptionEmpty, setIsDescriptionEmpty] = useState(false);
  const [isAttachmentTooLarge, setIsAttachmentTooLarge] = useState(false);
  const [ticketNumberFormat, setTicketNumberFormat] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    getSystemParameter()
      .then((response) => {
        if (response.status) {
          console.log("ticket number format", response.data);
          // generateTicketNumber(response.data);
          setTicketNumberFormat(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));
  }, []);

  const generateTicketNumber = async () => {
    if (ticketNumberFormat) {
      const count = (await getCaseCount("today")).data.Cnt + 1;
      const date = moment();

      const ticketNumber = ticketNumberFormat
        // Replace the date strings with current date using moment.js format method
        .replace("yyyy", date.format("YYYY"))
        .replace("mm", date.format("MM"))
        .replace("dd", date.format("DD"))

        // Replace the 'x' characters with 0, and add the current ticket count at the end
        .replace(/x+/gi, (match) =>
          count.toString().padStart(match.length, "0")
        );

      console.log("ticketNumber", ticketNumber);

      /* setFormData({
        ...formData,
        ticketno: ticketNumber,
        title: `TicketNo-${ticketNumber}`,
      }); */

      return ticketNumber;
    } else {
      // Set default value if ticketNumberFormat is undefined
      const ticketNumber = "yyyymmddxxxxxx";
      console.log(ticketNumber);

      /* setFormData({
        ...formData,
        ticketno: ticketNumber,
      }); */

      return "yyyymmddxxxxxx";
    }
  };

  const handleClose = () => {
    setTicketAction && setTicketAction("");
    setFormData(initialData);
    setIsDescriptionEmpty(false);
    setIsCreateTicketDialogShown && setIsCreateTicketDialogShown(false);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const ticketNumber = await generateTicketNumber();
    let description = null;

    if (
      (!formData.description.length ||
        formData.description === "<p><br></p>") &&
      (formData.contactid === 1 || formData.contactid === 18)
    ) {
      description = `Recording Ticket ${ticketNumber}`;
    }

    const updatedFormData = {
      ...formData,
      description: description ?? formData.description,
      ticketno: ticketNumber,
      title: `TicketNo-${ticketNumber}`,
    };

    const notificationPayload = {
      EventName: TICKET_CREATED,
      EventType: "INFO", // WARNING || INFO || ERROR
      // "Title": "Test Notification",
      Message: `${myInfo.user.AgentName} created a new ticket!`,
      // "Url": null,

      NotifyAgents: [
        {
          AgentName: myInfo.user.LeaderName, // Optional
          AgentCode: myInfo.user.LeaderCode, // Optional
          AgentID: myInfo.user.LeaderID,
        },
      ],
    };

    // Check for any attachment, validate first if attachment is present
    Object.keys(attachment).length > 0
      ? upload({ data: attachment })
          .then((response) => {
            if (response.status) {
              console.log("Upload success");
              console.log("form data: ", updatedFormData);

              insertTicket(updatedFormData)
                .then((response) => {
                  if (response.status) {
                    console.log("Output caseID", response.data.caseid);

                    // Send notification to leader
                    setSocketNotification({
                      ...notificationPayload,
                      RefNo: response.data.caseid,
                    })
                      .then((response) => {
                        if (response.status) {
                          console.log(
                            `Notification sent to ${myInfo.user.LeaderName}`
                          );
                        } else {
                          console.log("error", response.error);
                        }
                      })
                      .catch((err) => {
                        console.log("err", err);
                      });

                    handleClose();
                    handleEndChat && handleEndChat();
                    toast.success("Ticket created successfully", {
                      autoClose: 3000,
                    });
                    setIsSubmitting(false);
                    dispatch({ type: SET_GO_TO_ACW, payload: false });

                    // End call if in ACW
                    if (isInACW) {
                      dispatch({ type: RESET_CALL_STATE });
                      dispatch(stateAction("READY", undefined, "ACW", "Green"));
                    }

                    // To refetch contact ticket log data
                    dispatch({ type: GET_CONTACT_DETAILS });
                  } else {
                    console.log("error", response.error);
                    handleClose();
                    toast.error(`Error creating ticket! ${response?.error}`, { autoClose: 3000 });
                    setIsSubmitting(false);
                  }
                })
                .catch((err) => {
                  console.log("err", err);
                  handleClose();
                  toast.error(`Error creating ticket! ${err}`, { autoClose: 3000 });
                  setIsSubmitting(false);
                });
            } else {
              console.log("error", response.error);
              handleClose();
              toast.error("Error creating ticket", { autoClose: 3000 });
            }
          })
          .catch((err) => {
            console.log("err", err);
            handleClose();
            toast.error("Error creating ticket", { autoClose: 3000 });
          })
      : insertTicket(updatedFormData)
          .then((response) => {
            if (response.status) {
              console.log("Output caseID", response.data.caseid);

              // Send notification to leader
              setSocketNotification({
                ...notificationPayload,
                RefNo: response.data.caseid,
              })
                .then((response) => {
                  if (response.status) {
                    console.log(
                      `Notification sent to ${myInfo.user.LeaderName}`
                    );
                  } else {
                    console.log("error", response.error);
                  }
                })
                .catch((err) => {
                  console.log("err", err);
                });

              handleClose();
              handleEndChat && handleEndChat();
              toast.success("Ticket created successfully", { autoClose: 3000 });
              setIsSubmitting(false);
              dispatch({ type: SET_GO_TO_ACW, payload: false });

              // End call if in ACW
              if (isInACW) {
                dispatch({ type: RESET_CALL_STATE });
                dispatch(stateAction("READY", undefined, "ACW", "Green"));
              }

              // To refetch contact ticket log data
              dispatch({ type: GET_CONTACT_DETAILS });
            } else {
              console.log("error", response.error);
              handleClose();
              toast.error(`Error creating ticket! ${response?.error}`, { autoClose: 3000 });
              setIsSubmitting(false);
            }
          })
          .catch((err) => {
            console.log("err", err);
            handleClose();
            toast.error(`Error creating ticket! ${err}`, { autoClose: 3000 });
            setIsSubmitting(false);
          });

    handleClose();
  };

  return (
    <div className="dialog-container create-ticket">
      <div className="dialog-content">
        <div className="header-container">
          <h2 className="title">Create Ticket</h2>
          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>
        </div>
        <div className="form-container">
          <form
            method="post"
            onSubmit={(e) => {
              e.preventDefault();

              if (
                (!formData.description.length ||
                  formData.description === "<p><br></p>") &&
                (!formData.remark.length || formData.remark === "<p><br></p>")
              ) {
                setIsDescriptionEmpty(true);
              } else if (
                // Attachment size validation. Show error if attached file size exceeds 25 MB
                formData.attachment.some(
                  (attachment) => attachment.bodylength >= 26214400
                )
              ) {
                setIsAttachmentTooLarge(true);
              } else {
                setIsDescriptionEmpty(false);
                handleSubmit();
              }
            }}
          >
            <TicketFieldsForm
              formData={formData}
              setFormData={setFormData}
              setAttachment={setAttachment}
              customInput={customInput}
              setCustomInput={setCustomInput}
              isCustomInputLoading={isCustomInputLoading}
              setIsCustomInputLoading={setIsCustomInputLoading}
              isDescriptionEmpty={isDescriptionEmpty}
              setIsDescriptionEmpty={setIsDescriptionEmpty}
              isAttachmentTooLarge={isAttachmentTooLarge}
              setIsAttachmentTooLarge={setIsAttachmentTooLarge}
              isTicketFieldsLoading={isTicketFieldsLoading}
              setIsTicketFieldsLoading={setIsTicketFieldsLoading}
            />
            <section className="buttonsFloat">
              <button className="cancel" type="button" onClick={handleClose}>
                Cancel
              </button>

              <button
                className="confirm"
                disabled={
                  isSubmitting || isAttachmentTooLarge || isDescriptionEmpty
                }
                type="submit"
              >
                {isSubmitting && <CircularProgress className="progress" />}
                Submit
              </button>
            </section>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateTicket;
